import { render, staticRenderFns } from "./VenaSealPage.vue?vue&type=template&id=725bc885&scoped=true"
import script from "./VenaSealPage.vue?vue&type=script&lang=js"
export * from "./VenaSealPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725bc885",
  null
  
)

export default component.exports